module.exports = __webpack_public_path__ + "img/compact.c8190187.png";